import React, { useState } from "react";
import { AdminShell } from "./components/AdminShell";
import { AdminLogin, AdminPages } from "./pages/AdminPages";
import { ApplicantPages } from "./pages/ApplicantPages";
import { initialApplications } from "./data/btb";
import { ApplicationRecord, View } from "./types/system";
type AppProps = {
  initialMode?: "admin" | "applicant";
};
export function App({
  initialMode = "applicant"
}: AppProps) {
  const [view, setView] = useState<View>(initialMode === "admin" ? "login" : "applicant-home");
  const [applications, setApplications] = useState<ApplicationRecord[]>(initialApplications);
  const [notifications, setNotifications] = useState(4);
  const [published, setPublished] = useState(false);
  const isApplicant = ["applicant-home", "event-detail", "applicant-auth", "applicant-form", "applicant-preview", "submission-success", "applicant-dashboard", "tracking", "applicant-certificate"].includes(view);
  const go = (next: View) => setView(next);
  const updateStatus = (status: ApplicationRecord["status"], stage: string, score?: number) => {
    setApplications(items => items.map((item, index) => index === 0 ? {
      ...item,
      status,
      stage,
      ...(score ? {
        score
      } : {})
    } : item));
    setNotifications(count => count + 1);
  };
  if (view === "login") return <AdminLogin onLogin={() => go("dashboard")} onApplicant={() => go("applicant-home")} data-id="element-0" data-mp="5or2zhbcs60" />;
  if (isApplicant) return <ApplicantPages view={view} onNavigate={go} published={published} applications={applications} data-id="element-1" data-mp="2zllijblcf2rh" />;
  return <AdminShell view={view} onNavigate={go} onLogout={() => go("login")} notifications={notifications} data-id="element-2" data-mp="33lx02fiesmyq"><AdminPages view={view} onNavigate={go} applications={applications} updateStatus={updateStatus} published={published} onPublish={() => {
      setPublished(true);
      setNotifications(count => count + 3);
    }} data-id="element-3" data-mp="38li7lebna3n2" /></AdminShell>;
}